import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { HostBinding } from '@angular/core';
import { Input } from '@angular/core';

/**
 * Horizontal button container that distributes child buttons evenly.
 *
 * Use `upp-button-bar` with one or more `upp-button-bar-item` children.
 */
@Component({
    selector: 'upp-button-bar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-button-bar.html',
    styleUrls: ['./upp-button-bar.scss']
})
export class UppButtonBarComponent {
    /**
     * Space between items. Accepts any valid CSS size value.
     *
     * @default `'2px'`
     */
    @Input() gap = '2px';

    @HostBinding('style.--upp-button-bar-gap')
    get cssGap(): string {
        return this.gap;
    }
}

/**
 * Slot wrapper for an item inside `upp-button-bar`.
 */
@Component({
    selector: 'upp-button-bar-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<ng-content></ng-content>`,
    styleUrls: ['./upp-button-bar.scss']
})
export class UppButtonBarItemComponent {
    // nothing to do
}
